module.exports = __webpack_public_path__ + "img/cert-copy.12afeb63.svg";